(() => {
  const films = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width:749px)');
  const preferenceKey = 'aparu-video-motion';
  let userPaused = false;
  let reducedOverride = false;
  try { userPaused = localStorage.getItem(preferenceKey) === 'paused'; } catch (_) { /* Storage may be unavailable. */ }
  const motionPaused = () => userPaused || (reduced.matches && !reducedOverride);
  function remember(paused) {
    userPaused = paused;
    try { localStorage.setItem(preferenceKey, paused ? 'paused' : 'enabled'); } catch (_) { /* Keep the current-page preference. */ }
  }
  function controls() {
    const paused = motionPaused();
    const blocked = [...films.values()].some(state => state.blocked && state.ratio > .15);
    document.querySelectorAll('[data-aparu-motion-toggle]').forEach(button => {
      button.textContent = paused ? 'Bewegung abspielen' : 'Bewegung pausieren';
    });
    document.querySelectorAll('[data-aparu-motion-status]').forEach(label => {
      label.textContent = paused ? 'Videos pausiert' : blocked ? 'Automatischer Start nicht möglich' : 'Videos ohne Ton';
    });
    document.querySelectorAll('[data-aparu-motion-start]').forEach(button => { button.hidden = !blocked || paused; });
  }
  function source(state) {
    const url = mobile.matches ? state.video.dataset.mobile : state.video.dataset.desktop;
    if (url && state.video.getAttribute('src') !== url) {
      state.video.src = url;
      state.blocked = false;
    }
  }
  function play(state, explicit = false) {
    if (state.pending || (state.blocked && !explicit)) return;
    source(state);
    state.pending = true;
    const attempt = state.video.play();
    if (!attempt) { state.pending = false; return; }
    attempt.then(() => {
      state.pending = false;
      state.blocked = false;
      if (!state.desired || document.hidden || motionPaused()) state.video.pause();
      controls();
    }).catch(error => {
      state.pending = false;
      state.blocked = error.name !== 'AbortError';
      controls();
      if (!state.blocked) sync();
    });
  }
  function sync(explicit = false) {
    let winner = null;
    const paused = motionPaused();
    for (const [root, state] of films) {
      if (!root.isConnected) { state.video.pause(); state.observer.disconnect(); films.delete(root); continue; }
      if (paused || document.hidden || state.ratio <= .15 || state.localPaused) continue;
      if (!winner || state.ratio > winner.ratio) winner = state;
    }
    for (const state of films.values()) {
      state.desired = state === winner;
      if (state.desired) play(state, explicit);
      else {
        state.video.pause();
        if (reduced.matches && !reducedOverride && state.video.hasAttribute('src')) {
          state.video.removeAttribute('src');
          state.video.load();
        }
      }
    }
    controls();
  }
  function enable() {
    remember(false);
    reducedOverride = true;
    for (const state of films.values()) { state.localPaused = false; state.blocked = false; }
    sync(true);
  }
  function init() {
    document.querySelectorAll('[data-v4-film]').forEach(root => {
      if (films.has(root)) return;
      const video = root.querySelector('video');
      if (!video) return;
      const button = root.querySelector('.v4-film-toggle');
      video.dataset.desktopPoster = video.dataset.desktopPoster || video.poster;
      video.poster = mobile.matches && video.dataset.mobilePoster ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const state = { video, ratio: 0, localPaused: false, pending: false, blocked: false, desired: false, observer: null };
      const label = () => {
        if (!button) return;
        button.setAttribute('aria-label', video.paused ? 'Video abspielen' : 'Video pausieren');
        button.setAttribute('aria-pressed', String(!video.paused));
        const icon = button.querySelector('span');
        if (icon) icon.textContent = video.paused ? '▶' : 'Ⅱ';
      };
      video.addEventListener('play', label);
      video.addEventListener('pause', label);
      video.addEventListener('error', () => { state.blocked = true; controls(); });
      if (button) button.addEventListener('click', () => {
        if (!video.paused) { state.localPaused = true; video.pause(); }
        else { state.localPaused = false; enable(); }
      });
      state.observer = new IntersectionObserver(entries => { state.ratio = entries[0].intersectionRatio; sync(); }, { threshold: [0,.15,.3,.5,.7,.9,1] });
      films.set(root, state);
      state.observer.observe(root);
      label();
    });
    document.querySelectorAll('[data-aparu-motion-toggle]').forEach(button => {
      if (button.dataset.motionBound) return;
      button.dataset.motionBound = 'true';
      button.addEventListener('click', () => {
        if (motionPaused()) enable();
        else { remember(true); sync(); }
      });
    });
    document.querySelectorAll('[data-aparu-motion-start]').forEach(button => {
      if (button.dataset.motionBound) return;
      button.dataset.motionBound = 'true';
      button.addEventListener('click', enable);
    });
    controls();
  }
  mobile.addEventListener('change', () => {
    for (const state of films.values()) {
      state.video.poster = mobile.matches && state.video.dataset.mobilePoster ? state.video.dataset.mobilePoster : state.video.dataset.desktopPoster;
      if (state.video.hasAttribute('src')) source(state);
    }
    sync();
  });
  document.addEventListener('visibilitychange', () => sync());
  reduced.addEventListener('change', () => { reducedOverride = false; sync(); });
  window.addEventListener('storage', event => { if (event.key === preferenceKey) { userPaused = event.newValue === 'paused'; sync(); } });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
